import React from 'react';
import CurrenciesTable from '../components/CurrenciesTable';

export function Currencies() {
  return <CurrenciesTable />;
}
